import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePickerTrans from './components/date-picker-trans/date-picker-trans';
import { locale } from '../../locale/locale-utils';
import { DEFAULT_DATE_OPTIONS_OBJ } from './components/date-picker-trans/date-picker-constants';

export class DatePicker extends Component {
    static contextTypes = {
        router: PropTypes.object
    };

    static propTypes = {
        academicYear: PropTypes.shape({
            startDate: PropTypes.string,
            endDate: PropTypes.string
        }),
        currentDate: PropTypes.shape({
            type: PropTypes.string,
            startDate: PropTypes.string,
            endDate: PropTypes.string
        }),
        onDateChange: PropTypes.func,
        localeData: PropTypes.object,
        isLeft: PropTypes.bool
    }

    constructor(props) {
        super(props);
        this.state = {
            options: DEFAULT_DATE_OPTIONS_OBJ
        };
    }

    getTranslatedOptions = (options) => {
        const { localeData } = this.props;
        if (localeData) {
            return options.map((item) => {
                const label = localeData[`Date Filters - ${item.value}`];
                item.label = label || item.value;
                return item;
            });
        }
        return options;
    };

    calendarLocaleData = () => {
        const { localeData } = this.props;
        return ({
            'Label - StartDate': localeData['Label - StartDate'],
            'Label - EndDate': localeData['Label - EndDate'],
            'Label - Monday': localeData['Label - Monday'],
            'Label - Sunday': localeData['Label - Sunday']
        });
    }

    render() {
        const { academicYear, currentDate, onDateChange, isLeft } = this.props;
        const { options } = this.state;
        if (academicYear && currentDate && onDateChange) {
            return (
                <DatePickerTrans
                    currentDate={currentDate}
                    options={this.getTranslatedOptions(options)}
                    academicYear={academicYear}
                    onDateChange={onDateChange}
                    locale={locale()}
                    calendarLocaleData={this.calendarLocaleData()}
                    isLeft={isLeft}
                />
            );
        }
        return null;
    }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./components/date-picker/date-picker.js